import { render, staticRenderFns } from "./ConsultantTransferList.vue?vue&type=template&id=40be034f&scoped=true"
import script from "./ConsultantTransferList.vue?vue&type=script&lang=js"
export * from "./ConsultantTransferList.vue?vue&type=script&lang=js"
import style0 from "./ConsultantTransferList.vue?vue&type=style&index=0&id=40be034f&prod&lang=scss&scoped=true"
import style1 from "./ConsultantTransferList.vue?vue&type=style&index=1&id=40be034f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be034f",
  null
  
)

export default component.exports